<app-dialog (cancel)="cancel.emit()" [minWidthDefault]="false" [showHeader]="false" [show]="show">
  <div *ngIf="show" @fadeInOut class="enter-pin-dialog-container">
    <div class="header">
      <img *ngIf="isWitness" class="witness-icon" src="assets/icons/icon-users-active-filled.svg" alt="users">
      {{isWitness ? 'Witness Liability' : 'Enter PIN'}}
    </div>

    <div class="subheader">
      {{isWitness ? 'Please have a witness enter their 4-digit PIN.' : 'Please enter your 4-digit PIN to continue.'}}
    </div>

    <app-pin-input [(ngModel)]="pinValue"
                   (pinValueComplete)="codeComplete($event)"
                   [isLarge]="true"
                   [disabled]="isDisabled"
                   [invalid]="isInvalid"
                   [alibiError]="isWitnessPinInvalid"
                   [focused]="focusPin"
                   [errorPinCountMessage]="errorPinCountMessage"
    ></app-pin-input>

    <div class="text">
      All transactions that occur under this PIN will be associated with you.
    </div>

    <div class="controls">
      <button (click)="cancel.emit()" class="animation-focus-default cancel-btn">
        Cancel
      </button>

      <button (click)="handleResetPin.emit()" class="animation-focus-default forgot-pin-btn">
        I forgot my PIN
      </button>
    </div>
  </div>
</app-dialog>
